import * as React from "react";
function SvgIcMore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.019 8.198a2.292 2.292 0 102.546-3.811 2.292 2.292 0 00-2.546 3.811zm.417-3.188a1.544 1.544 0 111.446 2.707 1.542 1.542 0 01-1.446-2.707zM11.019 14.198a2.292 2.292 0 102.546-3.811 2.292 2.292 0 00-2.546 3.811zm.417-3.188a1.542 1.542 0 111.713 2.565 1.542 1.542 0 01-1.713-2.565zM11.018 20.197a2.292 2.292 0 102.547-3.81 2.292 2.292 0 00-2.547 3.81zm.417-3.187a1.544 1.544 0 012.138 2.139 1.54 1.54 0 11-2.138-2.14z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcMore;
